import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Wrench } from 'lucide-react';
import { useAuthContext } from '../../modules/auth';
import { LoginForm } from '../../components/admin/auth';
import { LoadingSpinner } from '../../components/shared';

export default function Login() {
  const location = useLocation();
  const { user, loading } = useAuthContext();
  const from = location.state?.from || '/admin';

  if (loading) {
    return <LoadingSpinner />;
  }

  if (user) {
    return <Navigate to={from} replace />;
  }

  return (
    <>
      <Helmet>
        <title>Admin Login | Parakh Services</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <Wrench className="h-12 w-12 text-blue-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Admin Login
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <LoginForm />
          </div>
        </div>
      </div>
    </>
  );
}